import { ethers, utils } from "ethers";
import { parseUnits } from "ethers/lib/utils";
import { useContext, useState } from "react";
import toast from "react-hot-toast";
import { WalletContext } from "../../scripts/context/WalletContext";
import Jazzicon from "react-jazzicon/lib/Jazzicon";
import { jsNumberForAddress } from "react-jazzicon";

export const SHORTEN_ADDRESS = (address) =>
  `${address.slice(0, 5)}...${address.slice(address.length - 4)}`;

export default function Purchase() {
  const { web3, setWeb3 } = useContext(WalletContext);
  const [amount, setAmount] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const bigNumberToFixed = (value) => 0.1.toFixed(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const web32 = new ethers.providers.Web3Provider(window.ethereum);

    if (loading) return;
    setLoading(true);

    if (web3.contracts.presale.data.stopPresale) return;
    if (
      web3.contracts.presale.data.max -
        bigNumberToFixed(web3.contracts.presale.data.claimer._balance) <=
      0
    ) {
      return setError("You have reached the limit of your balance");
    }

    if (amount) {
      const weiAmount = parseUnits(`${amount}`)
        .mul(`${web3.contracts.presale.data.tokenPrice}`)
        .div(parseUnits("1"))
        .toString();

      try {
        const res = await web3.contracts.presale.contract.buyToken(
          `${amount * Math.pow(10, web3.decimals)}`,
          {
            from: web3.account.address,
            value: weiAmount,
          }
        );

        toast.promise(
          res.wait().then(async (data) => {
            const balance = await web32.getBalance(data.from);
            setWeb3({
              ...web3,
              account: {
                ...web3.account,
                balance: Number(utils.formatUnits(balance, 18)).toFixed(4),
              },
            });
            const claimer = await web3.contracts.presale.contract.getClaimer();
            setWeb3({
              ...web3,
              contracts: {
                ...web3.contracts,
                presale: {
                  ...web3.contracts.presale,
                  data: {
                    ...web3.contracts.presale.data,
                    claimer,
                  },
                },
              },
            });

            setAmount("");
            setLoading(false);
          }),
          {
            loading: "buying...",
            success: `You bought ${amount} tokens`,
            error: (error) => error.message,
          }
        );
      } catch (error) {
        if (web3.account.balance < Number(amount).toFixed(4)) {
          setError("Insufficient funds");

          return;
        }
        toast.error("We found an error try again");
        console.log(error);
      }
      setError("");
      setLoading(false);
    } else {
      setError("Please enter a valid amount");
      setLoading(false);
    }
  };

  return (
    <>
      {web3.contracts.presale.data.stopPresale && (
        <div className="row">
          <div className="col-md-6 col-lg-5 mx-auto mt-0">
            <div className="d-flex align-items-center bg-light-warning rounded p-5 mb-9 status-div just-dark">
              <span className="svg-icon svg-icon-warning mr-5">
                <span className="svg-icon svg-icon-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z"
                        fill="#000000"
                        opacity="0.3"
                      ></path>
                      <rect
                        fill="#000000"
                        x="11"
                        y="9"
                        width="2"
                        height="7"
                        rx="1"
                      ></rect>
                      <rect
                        fill="#000000"
                        x="11"
                        y="17"
                        width="2"
                        height="2"
                        rx="1"
                      ></rect>
                    </g>
                  </svg>
                </span>
              </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span
                  href="#"
                  className="text-warning py-1 font-size-lg font-size-status"
                >
                  The Presale is now over.
                </span>
                <p
                  className="fw-bold d-block text-break text-warning-des"
                  style={{ zIndex: "1" }}
                >
                  We have concluded our presale stage, thank you for your
                  interest.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-6 col-lg-5 mx-auto mt-0">
          <div className="card card-custom gutter-b card-stretch">
            <div className="card-body d-flex flex-column p-0 position-relative">
              <form
                onSubmit={handleSubmit}
                className="card-spacer card-rounded flex-grow-1"
              >
                <div className="row m-0">
                  <div className="col px-0 py-3 mr-4">
                    <div className=" font-weight-bolder">
                      Purchasing $BULT can be done through Theta Fuel (TFUEL).
                    </div>
                  </div>
                </div>
                <div className="row mt-5 mx-0">
                  <div className="col bg-custom-purchase">
                    <div className="sc-17c8lce-2 bodOQc">
                      <div className="sc-17c8lce-4 fTIUty">
                        <div
                          className="sc-17c8lce-7 REkGz css-8visvh"
                          style={{ flexShrink: "0", userSelect: "none" }}
                        >
                          {web3.account.balance} TFuel
                        </div>
                        <button
                          id="web3-status-connected"
                          className="sc-bdnxRM bhVlig sc-tdn257-0 sc-tdn257-4 sc-wwio5h-1 sc-wwio5h-4 gbdlPl cVOjRk idVMnL lgdLLT"
                          type="button"
                        >
                          <p className="sc-wwio5h-5 bhIQsL">
                            {SHORTEN_ADDRESS(web3.account.address)}
                          </p>
                          <div size="16" className="sc-wwio5h-0 iFpLyI">
                            <Jazzicon
                              diameter={20}
                              seed={jsNumberForAddress(web3.account.address)}
                            />
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="amount" className="font-weight-bolder">
                        Amount
                      </label>
                      <div className="input-group input-group-lg input-group-solid">
                        <input
                          style={
                            error
                              ? {
                                  paddingInlineEnd: "3rem",
                                }
                              : {}
                          }
                          className={`form-control form-control-lg form-control-solid${
                            error ? " is-invalid" : ""
                          }`}
                          placeholder={`Minimum $BULT amount is ${
                            bigNumberToFixed(
                              web3.contracts.presale.data.claimer._balance
                            ) >= web3.contracts.presale.data.min
                              ? 1
                              : web3.contracts.presale.data.min
                          }`}
                          type="number"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          id="amount"
                          min={
                            bigNumberToFixed(
                              web3.contracts.presale.data.claimer._balance
                            ) >= web3.contracts.presale.data.min
                              ? 1
                              : web3.contracts.presale.data.min
                          }
                          max={
                            web3.contracts.presale.data.max -
                            bigNumberToFixed(
                              web3.contracts.presale.data.claimer._balance
                            )
                          }
                        />
                        <button
                          type="button"
                          className={`label label-custom label-inline py-3 h-30px font-weight-lighter mx-2 border-0${
                            web3.contracts.presale.data.max -
                              bigNumberToFixed(
                                web3.contracts.presale.data.claimer._balance
                              ) <=
                              0 || loading
                              ? " disabled"
                              : ""
                          }`}
                          disabled={
                            loading ||
                            !web3.contracts.presale.data
                              .remainingPresaleTotalSupply ||
                            !(
                              web3.contracts.presale.data.max -
                              bigNumberToFixed(
                                web3.contracts.presale.data.claimer._balance
                              )
                            )
                          }
                          onClick={() =>
                            web3.contracts.presale.data.max -
                              bigNumberToFixed(
                                web3.contracts.presale.data.claimer._balance
                              ) >
                              0 &&
                            setAmount(
                              web3.contracts.presale.data
                                .remainingPresaleTotalSupply <
                                web3.contracts.presale.data.max -
                                  bigNumberToFixed(
                                    web3.contracts.presale.data.claimer._balance
                                  )
                                ? web3.contracts.presale.data
                                    .remainingPresaleTotalSupply
                                : web3.contracts.presale.data.max -
                                    bigNumberToFixed(
                                      web3.contracts.presale.data.claimer
                                        ._balance
                                    )
                            )
                          }
                        >
                          Buy max:{" "}
                          {web3.contracts.presale.data
                            .remainingPresaleTotalSupply <
                          web3.contracts.presale.data.max -
                            bigNumberToFixed(
                              web3.contracts.presale.data.claimer._balance
                            )
                            ? web3.contracts.presale.data
                                .remainingPresaleTotalSupply
                            : web3.contracts.presale.data.max -
                              bigNumberToFixed(
                                web3.contracts.presale.data.claimer._balance
                              )}
                        </button>
                      </div>
                      {error && (
                        <div className="fv-plugins-message-container">
                          <div
                            data-field="amount"
                            data-validator={error}
                            className="fv-help-block"
                          >
                            {error}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 pt-6">
                  <div className="flex-grow-1">
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div className="d-flex align-items-center mr-2">
                        <div>
                          <span className="font-size-h6 text-dark">
                            Exchange Rate :
                          </span>
                        </div>
                      </div>
                      <span className="font-size-h6 text-dark font-weight-bolder">
                        1 $BULT ≈{" "}
                        {(
                          web3.contracts.presale.data.tokenPrice /
                          Math.pow(10, 18)
                        ).toFixed(4)}{" "}
                        TFUEL
                      </span>
                    </div>

                    <div className="d-flex align-items-center justify-content-between pb-6">
                      <div className="d-flex align-items-center mr-2">
                        <div>
                          <span className="font-size-h6 text-dark ">
                            Deducted Amount :
                          </span>
                        </div>
                      </div>
                      <span className="font-size-h6 text-dark font-weight-bolder">
                        {(
                          amount *
                          (web3.contracts.presale.data.tokenPrice /
                            Math.pow(10, 18))
                        ).toFixed(4)}{" "}
                        TFUEL
                      </span>
                    </div>

                    <button
                      type="submit"
                      className="w-100 btn btn-primary-custom"
                      disabled={
                        loading ||
                        web3.contracts.presale.data.stopPresale ||
                        web3.contracts.presale.data.max -
                          bigNumberToFixed(
                            web3.contracts.presale.data.claimer._balance
                          ) <=
                          0 ||
                        !web3.contracts.presale.data
                          .remainingPresaleTotalSupply ||
                        !(
                          web3.contracts.presale.data.max -
                          bigNumberToFixed(
                            web3.contracts.presale.data.claimer._balance
                          )
                        )
                      }
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
